"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.battleFinishEvent = exports.battleTurnEvent = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
exports.battleTurnEvent = (0, toolkit_1.createAction)("battleTurnEvent");
exports.battleFinishEvent = (0, toolkit_1.createAction)("battleFinishEvent");
